import { ActivityIcon } from "@icons";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { useToaster } from "@design-system/ToastMessages/useToaster";
import {
    setBusyClosesDemoStoredOn,
    useIsBusyClosesDemoStoredOn,
} from "@components/demo/busyClosesDemo/busyClosesDemoSwitch";
import { useIsKickStaff } from "@components/demo/busyClosesDemo/useBusyClosesDemoGate";
import styles from "./Commands.module.scss";
import { useCommands } from "./useCommands";

/** Staff command that switches this browser's busy closes demo on or off. */
export const BusyClosesDemoCommand = () => {
    const canToggle = useIsKickStaff();
    const isStoredOn = useIsBusyClosesDemoStoredOn();
    const { close } = useCommands();
    const toaster = useToaster();

    if (!canToggle) {
        return null;
    }

    return (
        <CommandItem
            value="Busy closes demo"
            keywords={["demo", "busy", "closes"]}
            onSelect={() => {
                setBusyClosesDemoStoredOn(!isStoredOn);
                close();
                toaster.toast(
                    isStoredOn ? "Busy closes demo off" : "Busy closes demo on",
                );
            }}
        >
            <ActivityIcon /> Busy closes demo
            <span className={styles.optionSublabel}>
                {isStoredOn ? "On" : "Off"}
            </span>
        </CommandItem>
    );
};
